// @flow

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { LINK_COLOR_PRIMARY, LINK_COLOR_SECONDARY } from 'styles/colors';
import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { EASE_IN_OUT_25 } from 'styles/transitions';

const CtaLink = styled<any>(Link)`
  ${TYPE_SCALE_F6};
  ${EASE_IN_OUT_25};
  ${FONT_WEIGHT_100};
  border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_PRIMARY};
  color: ${LINK_COLOR_PRIMARY};
  padding: 0;
  text-decoration: none;

  &:hover {
    color: ${LINK_COLOR_SECONDARY};
    border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_SECONDARY};
  }
`;

export default CtaLink;



// WEBPACK FOOTER //
// ./src/components/shared/cta-link/index.js